import { LOCALE } from "core/interfaces";

import type { KindTrimmed } from "~/common/interfaces/kind-trimmed";

export const getKindLinks = (locale: LOCALE, kinds: KindTrimmed[] = [], optionalFields: Record<string, any> = {}) =>
	kinds.map((kind) => {
		const defaultTranslation = kind.translations?.find(
			translation => translation.locale === LOCALE.ENGLISH
		);
		const translation = kind.translations?.find(
			translation => translation.locale === locale
		);

		return {
			id: kind.id,
			name: translation?.namePlural || "",
			link: {
				path: `/shop/${defaultTranslation?.namePlural.toLowerCase()}` || "",
				...optionalFields
			}
		};
	});
